import { axiosInstance as axios } from "services";

export const fetchCategoryOptions = async () => {
  const { data } = await axios.get("/pricing/master/labor/options");
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch category options");
  return data;
};

